import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3ce3f2b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "left-container" };
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_6 = {
    key: 0,
    class: "alert-box-warning"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "warningField" }, null, -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_9 = {
    key: 1,
    class: "text-[13px] xs:text-base text-success-icon mt-1 col-start-2 ml-1.5"
};
const _hoisted_10 = {
    key: 2,
    class: "text-[13px] xs:text-base text-danger-icon mt-1 col-start-2 ml-1.5"
};
const _hoisted_11 = { class: "right-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_select = _resolveComponent("hit-select");
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_panel = _resolveComponent("hit-panel");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_hit_button, {
                    "icon-size": "lg",
                    "suffix-icon": "back",
                    color: "accent",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('previousClick')))
                })
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.stepper_company_information')), 1),
                _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.company_form_verify_and_complete_your_company_details')), 1),
                (!_ctx.myObject.checkVatNumberBeforeAddAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(" " + _toDisplayString(_ctx.t('admin-ui.vat_number_not_checked')), 1)
                    ]))
                    : _createCommentVNode("", true),
                _hoisted_8,
                _createVNode(_component_hit_panel, {
                    size: "maximized",
                    resizable: false
                }, {
                    body: _withCtx(() => [
                        _createVNode(_component_hit_form, {
                            name: "myFifthForm",
                            value: _ctx.objectFormData,
                            validations: _ctx.validations,
                            "force-cancel-button-hidden": true,
                            "force-save-button-hidden": true
                        }, {
                            default: _withCtx(({ formData, validationState, }) => [
                                _createVNode(_component_hit_select, {
                                    name: "userLanguageSystem",
                                    class: "text-sm sm:text-base",
                                    value: formData.userLanguageSystem,
                                    "label-fields": ['designation'],
                                    options: _ctx.HitLanguageUtils.getSupportedLanguageOptions(),
                                    label: _ctx.t('admin-ui.language_system'),
                                    "validation-state": validationState.userLanguageSystem,
                                    filterable: false,
                                    clearable: false,
                                    onChange: _ctx.onChangeUserLanguageSystem
                                }, null, 8, ["value", "options", "label", "validation-state", "onChange"]),
                                _createVNode(_component_hit_input, {
                                    name: "vatNumber",
                                    class: "text-sm sm:text-base",
                                    value: formData.vatNumber,
                                    "validation-state": validationState.vatNumber,
                                    label: _ctx.t('admin-ui.label_vat_number'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    disabled: !_ctx.myObject.checkVatNumberBeforeAddAccount,
                                    onInput: _ctx.onChangeVatNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "disabled", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "designationLegal",
                                    class: "text-sm sm:text-base",
                                    value: formData.designationLegal,
                                    "validation-state": validationState.designationLegal,
                                    label: _ctx.t('admin-ui.label_legal_designation'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeDesignationLegal
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "street",
                                    class: "text-sm sm:text-base",
                                    value: formData.street,
                                    "validation-state": validationState.street,
                                    label: _ctx.t('admin-ui.label_street'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeStreet
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "houseNumber",
                                    class: "text-sm sm:text-base",
                                    value: formData.houseNumber,
                                    "validation-state": validationState.houseNumber,
                                    label: _ctx.t('admin-ui.label_house_number'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeHouseNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "boxNumber",
                                    class: "text-sm sm:text-base",
                                    value: formData.boxNumber,
                                    "validation-state": validationState.boxNumber,
                                    label: _ctx.t('admin-ui.box_number'),
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    onInput: _ctx.onChangeBoxNumber
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "postCode",
                                    class: "text-sm sm:text-base",
                                    value: formData.postCode,
                                    "validation-state": validationState.postCode,
                                    label: _ctx.t('admin-ui.label_post_code'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangePostCode
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "city",
                                    class: "text-sm sm:text-base",
                                    value: formData.city,
                                    "validation-state": validationState.city,
                                    label: _ctx.t('admin-ui.city'),
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangeCity
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "phone",
                                    class: "text-sm sm:text-base",
                                    value: formData.phone,
                                    "validation-state": validationState.phone,
                                    label: _ctx.t('admin-ui.label_phone'),
                                    type: "tel",
                                    placeholder: _ctx.t('admin-ui.required'),
                                    onInput: _ctx.onChangePhone
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "mobile",
                                    class: "text-sm sm:text-base",
                                    value: formData.mobile,
                                    "validation-state": validationState.mobile,
                                    label: _ctx.t('admin-ui.mobile'),
                                    type: "tel",
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    onInput: _ctx.onChangeMobile
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                _createVNode(_component_hit_input, {
                                    name: "activity",
                                    class: "text-sm sm:text-base",
                                    value: formData.activity,
                                    "validation-state": validationState.activity,
                                    label: _ctx.t('admin-ui.activity'),
                                    type: "text",
                                    placeholder: _ctx.t('admin-ui.optional'),
                                    onInput: _ctx.onChangeActivity
                                }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]),
                                (_ctx.enableReferralSystem === 'true')
                                    ? (_openBlock(), _createBlock(_component_hit_input, {
                                        key: 0,
                                        name: "referralCode",
                                        class: "text-sm sm:text-base",
                                        value: formData.referralCode,
                                        "validation-state": validationState.referralCode,
                                        label: _ctx.t('admin-ui.referral_code'),
                                        type: "text",
                                        placeholder: _ctx.t('admin-ui.optional'),
                                        onInput: _ctx.onChangeReferralCode
                                    }, null, 8, ["value", "validation-state", "label", "placeholder", "onInput"]))
                                    : _createCommentVNode("", true),
                                (_ctx.referralCodeValid &&
                                    _ctx.objectFormData.referralCode !== '' &&
                                    _ctx.objectFormData.referralCode !== null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.t('admin-ui.referral-code-is-valid')), 1))
                                    : (!_ctx.referralCodeValid &&
                                        _ctx.objectFormData.referralCode !== '' &&
                                        _ctx.objectFormData.referralCode !== null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t('admin-ui.referral-code-is-invalid')), 1))
                                        : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 8, ["value", "validations"])
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_hit_button, {
                    color: "accent",
                    disabled: !_ctx.allowNextClick,
                    "suffix-icon": "forward",
                    "icon-size": "lg",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('nextClick', _ctx.getAllValues())))
                }, null, 8, ["disabled"])
            ])
        ])
    ]));
}
